module.exports = __webpack_public_path__ + "media/images/event-button-img-8a988584cb6a168488a4b802493f12b0.png";